export var CompletionItemKind;
(function (CompletionItemKind) {
    CompletionItemKind["GroupTitle"] = "GroupTitle";
})(CompletionItemKind || (CompletionItemKind = {}));
//# sourceMappingURL=completion.js.map